import { HomeIcon } from "@heroicons/react/24/solid";

export default function BannerBottom() {
  return (
    <div className="sticky py-5 inset-x-0 bottom-0 w-full text-center z-10 -mt-1 pt-4  isolate flex items-center gap-x-6 text-white overflow-hidden dark:bg-black bg-gray-500 px-2 sm:px-1.5 justify-center align-center ">
      <div
        className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#000000] to-[yellow] opacity-30"
          style={{
            clipPath:
              "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
          }}
        />
      </div>
      <div
        className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#000000] to-[yellow] opacity-30"
          style={{
            clipPath:
              "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
          }}
        />
      </div>{" "}
      <div className="flex w-fit ml-2 sm:w-fit  flex-row items-center justify-center">
        <HomeIcon
          className="mr-1  text-yellow-600 pulse ml-1 sm:mr-3 h-6 w-6 pb-1 sm:pb-0"
          aria-hidden="true"
        />
        <p className="flex text-sm leading-none font-semibold">
          Our Appraisers Specialize In:
        </p>
      </div>
      <div className="w-full sm:w-8/12 overflow-x-auto sm:overflow-hidden">
        <div className="flex items-center gap-x-4 gap-y-2 whitespace-nowrap animate-marquee font-light">
         
          <a href="#whatwedo" className="ticker-item">
            Residential Property Appraisal
          </a>   
 <a href="#whatwedo" className="ticker-item">
            Divorce Matrimonial Appraisal
          </a> 
          <a href="#whatwedo" className="ticker-item">
            Capital Gains Tax Appraisal
          </a>
          <a href="#whatwedo" className="ticker-item">
            Probate Estate Appraisal
          </a>
         <a href="#whatwedo" className="ticker-item">
            Mortgage Financing Appraisal
          </a>
          <a href="#whatwedo" className="ticker-item">
            Pre-Buying/Pre-Listing Appraisal
          </a>
        </div>
      </div>
    </div>
  );
}
